import Vue from 'vue'
import Vuex from 'vuex'
import { vuexOidcCreateStoreModule } from 'vuex-oidc';
import { oidcSettings } from '../config/oidc';
import jwt from 'jsonwebtoken';

import appUsers from './modules/AppUsersStore';
import notificationStore from './modules/notificationStore';
import entrySidebar from './modules/EntrySidebar';
import allocations from './modules/allocations';
import circles from './modules/circles';
import groupStore from './modules/groupStore';
import groupTemplateStore from './modules/groupTemplateStore';
import employees from './modules/employees';
import forecasts from './modules/forecasts';
import metadata from './modules/metadata';
import milestones from './modules/milestones';
import replacementAllocations from './modules/ReplacementAllocations';
import scheduler from './modules/scheduler';
import groupComments from './modules/GroupCommentStore';
import reportStore from './modules/reportStore';
import salaryReportStore from './modules/salaryReportStore';
import holidayStore from './modules/holidayStore';
import statisticsStore from './modules/statisticsStore';
import allocationMoverStore from './modules/allocationMoverStore';
import agreementStore from './modules/agreementStore';
import gpsDataStore from './modules/gpsDataStore';
import generalStatisticsFilteringSidebar from './modules/GeneralStatisticsFilteringSidebar'
import salaryTypeFilteringSidebar from './modules/salaryTypeFilteringSidebar'
import confirmationModalStore from './modules/confirmationModalStore'
import dtReportStore from './modules/dtReportStore'
import salaryRateStore from './modules/salaryRateStore';
import csvModalStore from './modules/csvModalStore'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    currentUser: {},
    viewAs: { employee: undefined, group: undefined },
    isAdmin: false,
    isReplacement: false,
    hasEditRights: true
  },
  mutations: {
    setCurrentUser(state, userInfo) {
      state.currentUser = userInfo;
    },
    setViewAs(state, employeeAndGroup) {
      state.viewAs = employeeAndGroup;
    }
  },
  actions: {
    userLoaded({ commit }, user) {
      const decoded = jwt.decode(user.access_token);
      commit('setCurrentUser', { name: decoded.Name, role: decoded.Role, email: decoded.Email, id: decoded.sub, groupId: decoded.GroupId, number: decoded.Number, icalendarKey: decoded.ICalendarKey, isSalaryReportOpen: decoded.IsSalaryReportOpen });
    },
    userUnloaded({ commit }) {
      commit('setCurrentUser', { name: 'Not logged in', role: '', email: '', id: '', number: 0, icalendar: null, isSalaryReportOpen: null });
    },
    setViewAs({ commit }, employeeAndGroup) {
      commit('setViewAs', employeeAndGroup);
    },
    clearViewAs({ commit }) {
      commit('setViewAs', { employee: undefined, group: undefined });
    }
  },
  getters: {
    // Contains the currently logged-in user, or the user currently being impersonated
    currentUser: (state) => (state.viewAs.employee) ? state.viewAs.employee : state.currentUser,

    // Role of the currently logged-in user, regardless of impersonation
    currentRole: (state) => (state.currentUser) ? state.currentUser.role : "---",

    // Administrator state of the currently logged-in user, regardless of impersonation
    isAdmin: (state) => state.currentUser && state.currentUser.role === "Admin",

    // Replacement state of the currently logged-in user
    isReplacement: (state) => state.currentUser && state.currentUser.role === "Replacement",

    // State of the currently logged-in user
    hasEditRights: (state) => state.currentUser && state.currentUser.number !== 1014 && state.currentUser.email !== "1014@vikingdanmark.dk",

    // User currently being impersonated, otherwise undefined
    viewAsEmployee: state => state.viewAs.employee,

    // Group of user currently being impersonated, otherwise undefined
    viewAsGroup: state => state.viewAs.group,

    icalendarKey: (state) => state.currentUser.icalendarKey,

    // isSalaryReportOpen
    isSalaryReportOpen: (state) => state.currentUser && state.currentUser.isSalaryReportOpen,
  },
  modules: {
    allocations,
    appUsers,
    allocationMoverStore,
    circles,
    employees,
    entrySidebar,
    forecasts,
    groupComments,
    metadata,
    milestones,
    scheduler,
    replacementAllocations,
    salaryReportStore,
    reportStore,
    notificationStore,
    groupStore,
    groupTemplateStore,
    holidayStore,
    statisticsStore,
    agreementStore,
    gpsDataStore,
    generalStatisticsFilteringSidebar,
    salaryTypeFilteringSidebar,
    confirmationModalStore,
    dtReportStore,
    salaryRateStore,
    csvModalStore,
    oidcStore: vuexOidcCreateStoreModule(
      oidcSettings,
      // ...
      {
        namespaced: true,
        dispatchEventsOnWindow: true
      },
      // OIDC Event listeners
      {
        userLoaded: (user) => store.dispatch('userLoaded', user),
        userUnloaded: () => store.dispatch('userUnloaded'),
        accessTokenExpiring: () => console.log('Access token will expire'),
        accessTokenExpired: () => console.log('Access token did expire'),
        silentRenewError: () => console.log('OIDC user is unloaded'),
        userSignedOut: () => console.log('OIDC user is signed out'),
        oidcError: (payload) => console.log('OIDC error', payload),
        automaticSilentRenewError: (payload) => console.log('OIDC automaticSilentRenewError', payload)
      }
    )
  }
})

export default store;
